import { QRoutes } from "../components/4_Qualifications/QRoutes"

export const Qualifications = () => {
    return (
        <div>
            <QRoutes />
        </div>
    )
}



